import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { MessageService } from 'primeng/api';
import { NgFor, NgIf, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { DecimalPipe } from '@angular/common';
import { UtilService } from '../../services/util.service';
import { RouterLink } from '@angular/router';
import {
  buildProductContext,
  buildServicesPayloadV11,
  ServiceInput,
  ServiceKind,
} from '../services/service-order-payload.builder';

@Component({
  selector: 'app-add-services-modal',
  imports: [NgStyle, FormsModule, NgIf, NgFor, DecimalPipe, RouterLink],
  providers: [MessageService],
  templateUrl: './add-services-modal.component.html',
  styleUrl: './add-services-modal.component.css',
})
export class AddServicesModalComponent implements OnInit {
  @Input() addNewConfig: boolean = false;
  @Input() type!: string;
  @Input() updateService: boolean = false;
  @Input() openNotes: boolean = false;
  @Input() filterServices: any[] = [];
  @Input() selectedProduct: any = {};
  @Input() selectedCartId!: string;
  @Input() qty = 1;
  @Input() serviceEdited = false;
  @Input() showPdfOption: boolean = false;
  @Input() fileUploaded: boolean = false;
  @Input() filename: string = '';
  @Input() pdfFileName!: string;

  @Output() onBack = new EventEmitter<void>();
  services = [
    { name: 'Slitting', qty: 1, productOptionType: 3, notes: '' },
    { name: 'Cutting', qty: 1, productOptionType: 0, notes: '' },
    { name: 'Bending', qty: 1, productOptionType: 1, notes: '' },
    { name: 'Punching', qty: 1, productOptionType: 2, Punching: false },
  ];
  selectedService: any = null;
  tempNotes: string = '';
  @ViewChild('fileInput') fileInput!: ElementRef;
  onClose!: Subject<any>;
  constructor(
    private api: ApiService,
    private messageService: MessageService,
    public modalRef: BsModalRef,
    private util: UtilService
  ) { }
  ngOnInit(): void {
    if (this.selectedProduct?.options?.length) {
      this.qty = this.selectedProduct?.qty;
    }

    this.onClose = new Subject();
    console.log(
      this.selectedProduct, this.filterServices,
      ' selected product and services initialized'
    );
  }
  handleOptionMinus(index: number) {
    if (this.filterServices[index].qty > 1) {
      this.filterServices[index].qty -= 1;
    }
  }
  handleOptionPlus(index: number) {
    this.filterServices[index].qty += 1;
  }
  get anyServiceSelected(): boolean {
    return this.filterServices.some((s: any) => s.selected);
  }
  selectService(index: number) {
    this.filterServices[index].selected = !this.filterServices[index].selected;
    if (this.anyServiceSelected && this.qty > this.selectedProduct.qty) {
      this.qty = this.selectedProduct.qty;
    }
  }
  removeService(index: number) {
    this.filterServices[index].selected = false;
    this.filterServices[index].qty = 1;
  }
  openNotesModal(service: any): void {
    this.selectedService = service;
    this.tempNotes = service.notes || '';
  }
  async onAddPdf() {
    await this.fileInput.nativeElement.click();
  }
  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      const formData = new FormData();
      formData.append('file', file);

      let res = await this.api.uploadFile(formData);
      this.pdfFileName = res.fileURL;
      this.filename = res.fileName;
      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `File ${this.filename} Uploaded Successfuly`,
          life: 2000,
        });
        this.fileUploaded = true;
      }
    }
  }
  onClickRemovePDF() {
    this.fileUploaded = false;
    this.pdfFileName = '';
  }
  private serviceKindFromName(name: string): ServiceKind {
    const n = (name || '').toLowerCase();
    if (n.includes('bend')) return 'bending';
    if (n.includes('punch')) return 'punching';
    if (n.includes('slit')) return 'slitting';
    return 'cutting';
  }

  /** Build the v2.0 services object for the simple modal flow. The modal captures
   *  no geometry, so cut/bend counts are synthesized from each service qty to keep
   *  the billed quantities consistent with the structure the backend validates. */
  private buildServicesObject(product: any, qty: number, serviceItems: any[], cartId?: string) {
    const services: ServiceInput[] = (serviceItems || []).map((svc: any) => {
      const kind = this.serviceKindFromName(svc?.name);
      const matched = product?.productOptionsDTO?.find(
        (o: any) => o.productOptionType?.toLowerCase() === svc?.name?.toLowerCase()
      );
      const q = Math.max(1, Math.round(Number(svc?.qty) || 1));
      const input: ServiceInput = {
        kind,
        pricing: {
          basePrice: Number(matched?.minimumServiceFee) || 0,
          includedQuantity: Number(matched?.includedQtyInMinimumFee) || 0,
          additionalUnitPrice: Number(matched?.eachAdditionalPrice) || 0,
        },
        notes: svc?.notes,
        attachment: svc?.FileName ? { name: this.filename, url: svc.FileName } : null,
      };
      if (kind === 'bending') {
        input.bendRows = Array.from({ length: q }, () => ({ distance: null, direction: 'up' as const, angle: 90 }));
      } else {
        input.measurements = [{ width: null, length: 1, qty: q }];
      }
      return input;
    });

    return buildServicesPayloadV11({
      product: buildProductContext(product),
      qty: qty || 1,
      notes: (serviceItems || []).find((s: any) => s?.notes)?.notes,
      services,
      attachment: this.pdfFileName ? { name: this.filename, url: this.pdfFileName } : null,
      now: new Date().toISOString(),
      orderId: cartId,
    });
  }

  async addCartOptions() {
    if (this.pdfFileName) {
      this.filterServices = this.filterServices.map((service: any) => {
        if (service.name === 'Cutting') {
          return {
            ...service,
            FileName: this.pdfFileName,
          };
        }
        return service;
      });
    }

    try {
      const product = this.selectedProduct?.product || this.selectedProduct;
      if (this.type === 'quotes') {
        const services = this.buildServicesObject(product, this.qty, this.filterServices, this.selectedCartId);
        const payload = {
          QuoteId: this.selectedCartId,
          qty: this.qty,
          services,
        };
        var res = await this.api.addOptions(payload);
      } else {
        const cartId = this.addNewConfig ? this.selectedProduct.cartId : this.selectedCartId;
        const serviceItems = this.addNewConfig
          ? this.filterServices.filter((s: any) => s.selected)
          : this.filterServices;
        const services = this.buildServicesObject(product, this.qty, serviceItems, cartId);
        const payload = {
          cartId: cartId,
          qty: this.qty,
          services,
        };
        var res = await this.api.addCartOptions(payload);
      }

      if (res) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Selected services added successfully.',
          life: 2000,
        });

        if (this.onClose) {
          this.onClose.next(res);
        }
        if (this.modalRef) {
          this.modalRef.hide();
        }
        if (this.addNewConfig) {
          let data = await this.api.getCartList();
          this.util.CartUpdated(data);
          this.onBack.emit(this.selectedProduct);
        }
      }
    } catch (error: any) {
      if (error.error?.warnings && error.error.warnings.length > 0) {
        Swal.fire({
          title: 'Warning',
          text: error.error.warnings[0],
          icon: 'warning',
          confirmButtonText: 'OK',
        });
        return;
      }

      console.error('Error adding cart options', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to add services to cart.',
        life: 2000,
      });
    }
  }
  saveNotes(): void {
    if (this.selectedService) {
      this.selectedService.notes = this.tempNotes;
      this.tempNotes = '';
    }
  }
  plus() {
    if (this.anyServiceSelected && this.qty >= this.selectedProduct.qty) return
    this.qty = this.qty + 1;
  }

  minus() {
    if (this.qty > 1) {
      this.qty = this.qty - 1;
    }
  }
}
